module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_front"
  }, [_vm._v("List of maps")]), _vm._v(" "), _c('p', {
    staticClass: "order_list"
  }, [_c('span', {
    staticClass: "order_hang"
  }, [_vm._v("1.")]), _vm._v(" The threat to Europe from the Ottoman Empire.")]), _vm._v(" "), _c('p', {
    staticClass: "order_list"
  }, [_c('span', {
    staticClass: "order_hang"
  }, [_vm._v("2.")]), _vm._v(" The Sykes-Picot Agreement of 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "order_list"
  }, [_c('span', {
    staticClass: "order_hang"
  }, [_vm._v("3.")]), _vm._v(" Islamic State territory in June 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "order_list"
  }, [_c('span', {
    staticClass: "order_hang"
  }, [_vm._v("4.")]), _vm._v(" A possible Kurdistan.")]), _vm._v(" "), _c('p', {
    staticClass: "order_list"
  }, [_c('span', {
    staticClass: "order_hang"
  }, [_vm._v("5.")]), _vm._v(" The once and future caliphate.")]), _vm._v(" "), _c('p', {
    staticClass: "order_list"
  }, [_c('span', {
    staticClass: "order_hang"
  }, [_vm._v("6.")]), _vm._v(" The Baltic states and their big near neighbour.")]), _vm._v(" "), _c('p', {
    staticClass: "order_list"
  }, [_c('span', {
    staticClass: "order_hang"
  }, [_vm._v("7.")]), _vm._v(" Disputes in the South China Sea.")]), _vm._v(" "), _c('p', {
    staticClass: "order_list"
  }, [_c('span', {
    staticClass: "order_hang"
  }, [_vm._v("8.")]), _vm._v(" US bases and military facilities around the world.")]), _vm._v(" "), _c('p', {
    staticClass: "pbrk"
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/map_1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("The threat to Europe from the Ottoman Empire.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/map_2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("The Sykes-Picot Agreement of 1916.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/map_3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("Islamic State territory in June 2014.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/map_4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("A possible Kurdistan.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/map_5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("The once and future caliphate.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/map_6.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("The Baltic states and their big near neighbour.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/map_7.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("Disputes in the South China Sea.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/map_8.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("US bases and military facilities around the world.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74955de2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Maps.vue
// module id = 72
// module chunks = 0